import { render, staticRenderFns } from "./DuaMessageCancelSection.vue?vue&type=template&id=4138a61b"
import script from "./DuaMessageCancelSection.vue?vue&type=script&lang=js"
export * from "./DuaMessageCancelSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports